import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ContentContainer,
  ModalTitle,
  ModalText,
  ButtonsContainer,
  CancelButton,
  DeleteButton,
} from "./DeleteCustomProcedureModal.styled";

interface DeleteCustomProcedureModalContentProps {
  procedureName: string;
  onDelete: () => void | Promise<void>;
  onClose: () => void;
}

const DeleteCustomProcedureModalContent: React.FC<
  DeleteCustomProcedureModalContentProps
> = ({ onDelete, onClose }) => {
  const { t } = useTranslation();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await onDelete();
      onClose();
    } catch (error) {
      console.error("Error deleting procedure:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <ContentContainer>
      <ModalTitle>
        {t("deleteCustomProcedureModal.title", "Delete Custom Procedure")}
      </ModalTitle>

      <ModalText>
        {t(
          "deleteCustomProcedureModal.message",
          "Are you sure you want to delete this procedure?"
        )}
      </ModalText>

      <ButtonsContainer>
        <CancelButton
          variant="outlined"
          onClick={onClose}
          disabled={isDeleting}
        >
          {t("deleteCustomProcedureModal.cancel", "Cancel")}
        </CancelButton>
        <DeleteButton
          variant="contained"
          onClick={handleDelete}
          disabled={isDeleting}
        >
          {isDeleting ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            t("deleteCustomProcedureModal.delete", "Delete")
          )}
        </DeleteButton>
      </ButtonsContainer>
    </ContentContainer>
  );
};

export default DeleteCustomProcedureModalContent;

